import { render } from "./SponsorsSlide.vue?vue&type=template&id=399dc63c&scoped=true"
import script from "./SponsorsSlide.vue?vue&type=script&lang=js"
export * from "./SponsorsSlide.vue?vue&type=script&lang=js"

import "./SponsorsSlide.vue?vue&type=style&index=0&id=399dc63c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399dc63c"]])

export default __exports__